import { render, staticRenderFns } from "./thirdPartyPlatformList.vue?vue&type=template&id=4d2cbc84"
import script from "./thirdPartyPlatformList.vue?vue&type=script&lang=js"
export * from "./thirdPartyPlatformList.vue?vue&type=script&lang=js"
import style0 from "./thirdPartyPlatformList.vue?vue&type=style&index=0&id=4d2cbc84&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports